enum OrderEntryViewStateOptionsEnum {
    ORDER_ENTRY = "ORDER_ENTRY",
    PURCHASE_ORDER = "PURCHASE_ORDER",
    BACKORDER = "BACKORDER",
    ACKNOWLEDGE = "ACKNOWLEDGE",
    ECOMMERCE = "ECOMMERCE",
    RMA = "RMA",
    DEALLOCATE = "DEALLOCATE",
}

export default OrderEntryViewStateOptionsEnum;
